"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BL_ORDER_CATEGORY_LABELS = exports.blOrderCategorySchema = exports.BL_ORDER_CATEGORIES = void 0;
const zod_1 = require("zod");
exports.BL_ORDER_CATEGORIES = [
    'shipping',
    'commercial',
    'certificates',
    'invoices',
    'other',
];
exports.blOrderCategorySchema = zod_1.z.enum(exports.BL_ORDER_CATEGORIES);
exports.BL_ORDER_CATEGORY_LABELS = {
    shipping: 'Shipping',
    commercial: 'Commercial',
    certificates: 'Certificates',
    invoices: 'Invoices',
    other: 'Other',
};
//# sourceMappingURL=bl-order-categories.js.map